export type LocaleKey = 
  | 'loading'
  | 'orderNotFound'
  | 'introText'
  | 'namePlaceholder'
  | 'nameLabel'
  | 'emailPlaceholder'
  | 'emailLabel'
  | 'acceptTermsPrefix'
  | 'termsLink'
  | 'submitting'
  | 'submit'
  | 'invalidOrderId'
  | 'orderLoadError'
  | 'emailCorrected'
  | 'welcome'
  | 'memoryError'
  | 'valNameMin'
  | 'valNameMax'
  | 'valEmailInvalid'
  | 'valEmailMax'
  | 'valMustAccept'
  | 'preparing'
  | 'shareMemory'
  | 'collaboration'
  | 'thanksVisit'
  | 'memorySoon'
  | 'memoryErrorStatus'
  | 'downloadError'
  | 'myMemoryAt'
  | 'theRestaurant'
  | 'termsTitle'
  | 'termsSubtitle'
  | 'close'
  | 'termsContent';

export const locales: Record<string, Record<LocaleKey, string>> = {
  es: {
    loading: 'Cargando...',
    orderNotFound: 'Orden no encontrada',
    introText: 'Gracias por visitar {name}. Dinos quién eres para poder valorar tu experiencia.',
    namePlaceholder: 'Nombre',
    nameLabel: 'Nombre',
    emailPlaceholder: 'Dirección de correo electrónico',
    emailLabel: 'Dirección de correo electrónico',
    acceptTermsPrefix: 'Acepto los ',
    termsLink: 'Términos y Condiciones',
    submitting: 'CARGANDO...',
    submit: 'CONTINUAR',
    invalidOrderId: 'ID de orden inválido',
    orderLoadError: 'No se pudo cargar la orden',
    emailCorrected: 'Email corregido automáticamente a: {email}',
    welcome: '¡Bienvenido!',
    memoryError: 'Error al crear la memoria. Por favor, inténtalo de nuevo.',
    valNameMin: 'El nombre debe tener al menos 2 caracteres',
    valNameMax: 'El nombre es demasiado largo',
    valEmailInvalid: 'Introduce un email válido',
    valEmailMax: 'El email es demasiado largo',
    valMustAccept: 'Debes aceptar los términos y condiciones',
    preparing: 'PREPARANDO...',
    shareMemory: 'COMPARTIR RECUERDO',
    collaboration: 'Recuerdos ofrecidos en colaboración con KOMBU',
    thanksVisit: 'Gracias por tu visita a {name}',
    memorySoon: 'Tu recuerdo llegará pronto a tu correo',
    memoryErrorStatus: 'Hubo un problema generando tu recuerdo',
    downloadError: 'Error al descargar el video',
    myMemoryAt: 'Mi recuerdo en {name}',
    theRestaurant: 'el restaurante',
    termsTitle: 'Términos y Condiciones',
    termsSubtitle: 'Lee atentamente antes de continuar',
    close: 'Cerrar',
    termsContent: `## Términos y Condiciones

### 1. Aceptación de los Términos

Al acceder y utilizar esta plataforma, aceptas estar obligado por estos términos y condiciones de uso. Si no estás de acuerdo con alguna parte de estos términos, no puedes usar nuestros servicios.

### 2. Descripción del Servicio

KOMBU es una plataforma que transforma experiencias gastronómicas en recuerdos audiovisuales personalizados. Te permite calificar platos, subir una fotografía y recibir un video personalizado de tu experiencia.

### 3. Requisitos de Uso

- Debes tener al menos 18 años de edad.
- Eres responsable de mantener la confidencialidad de tu información personal.
- Proporcionarás información precisa, honesta y completa.
- Eres responsable de todas las actividades que ocurran en tu cuenta.

### 4. Privacidad y Datos Personales

Tu privacidad es importante para nosotros. Recopilamos y procesamos tus datos personales (nombre y correo electrónico) para:
- Crear y gestionar tu memoria personalizada.
- Generar tu video personalizado.
- Enviarte tu contenido generado.
- Mejorar nuestros servicios.

Tus datos se procesarán de acuerdo con nuestra Política de Privacidad y la legislación aplicable.

### 5. Fotografías y Contenido

- Asegúrate de tener derecho a utilizar cualquier fotografía que subas.
- Consientes que KOMBU procese tu fotografía para generar el video personalizado.
- Eres responsable del contenido que subas y de cualquier violación de derechos de terceros.

### 6. Generación de Vídeo

- KOMBU utiliza tecnología automatizada para generar tu video personalizado.
- El video se crea basándose en tus calificaciones, fotografía y la información del restaurante.
- Nos reservamos el derecho a mejorar el proceso de generación de videos en cualquier momento.

### 7. Propiedad Intelectual

- Todo el contenido y tecnología en KOMBU (excepto tu contenido) es propiedad de KOMBU.
- No puedes reproducir, distribuir o transmitir ningún contenido sin autorización.
- Tu video personalizado es para uso personal. No está permitida su venta, comercialización ni distribución pública sin permiso.

### 8. Limitación de Responsabilidad

KOMBU se proporciona "tal cual" sin garantías de ningún tipo. No somos responsables de:
- Interrupciones o fallos técnicos en el servicio.
- Pérdida o corrupción de datos.
- Daños indirectos, incidentales o consecuentes derivados del uso de nuestros servicios.

### 9. Cookies y Tecnologías de Seguimiento

Utilizamos cookies y tecnologías similares para:
- Mejorar tu experiencia de usuario.
- Recordar tus preferencias.
- Analizar el uso de nuestros servicios.

Puedes controlar las cookies a través de la configuración de tu navegador.

### 10. Modificación de Términos

Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigencia cuando se publiquen en nuestro sitio. Tu uso continuado del servicio constituye aceptación de los términos modificados.

### 11. Terminación

Podemos suspender o terminar tu acceso a KOMBU si violas estos términos o por otros motivos.

### 12. Ley Aplicable

Estos términos se rigen por las leyes aplicables, y cualquier disputa se resolverá en los tribunales correspondientes.

### 13. Contacto

Si tienes preguntas sobre estos términos, contáctanos en support@kombu.com`,
  },
  en: {
    loading: 'Loading...',
    orderNotFound: 'Order not found',
    introText: 'Thank you for visiting {name}. Tell us who you are to rate your experience.',
    namePlaceholder: 'Name',
    nameLabel: 'Name',
    emailPlaceholder: 'Email address',
    emailLabel: 'Email address',
    acceptTermsPrefix: 'I accept the ',
    termsLink: 'Terms and Conditions',
    submitting: 'LOADING...',
    submit: 'CONTINUE',
    invalidOrderId: 'Invalid order ID',
    orderLoadError: 'Could not load the order',
    emailCorrected: 'Email automatically corrected to: {email}',
    welcome: 'Welcome!',
    memoryError: 'Error creating memory. Please try again.',
    valNameMin: 'Name must be at least 2 characters',
    valNameMax: 'Name is too long',
    valEmailInvalid: 'Please enter a valid email',
    valEmailMax: 'Email is too long',
    valMustAccept: 'You must accept the terms and conditions',
    preparing: 'PREPARING...',
    shareMemory: 'SHARE MEMORY',
    collaboration: 'Memories offered in collaboration with KOMBU',
    thanksVisit: 'Thank you for visiting {name}',
    memorySoon: 'Your memory will arrive in your email soon',
    memoryErrorStatus: 'There was a problem generating your memory',
    downloadError: 'Error downloading video',
    myMemoryAt: 'My memory at {name}',
    theRestaurant: 'the restaurant',
    termsTitle: 'Terms and Conditions',
    termsSubtitle: 'Please read carefully before continuing',
    close: 'Close',
    termsContent: `## Terms and Conditions

### 1. Acceptance of Terms

By accessing and using this platform, you agree to be bound by these terms and conditions. If you do not agree with any part of these terms, you may not use our services.

### 2. Service Description

KOMBU is a platform that transforms dining experiences into personalized audiovisual memories. It allows you to rate dishes, upload a photo, and receive a personalized video of your experience.

### 3. Usage Requirements

- You must be at least 18 years of age.
- You are responsible for maintaining the confidentiality of your personal information.
- You will provide accurate, honest, and complete information.
- You are responsible for all activities that occur on your account.

### 4. Privacy and Personal Data

Your privacy is important to us. We collect and process your personal data (name and email) to:
- Create and manage your personalized memory.
- Generate your personalized video.
- Send you your generated content.
- Improve our services.

Your data will be processed in accordance with our Privacy Policy and applicable legislation.

### 5. Photographs and Content

- Ensure you have the right to use any photograph you upload.
- You consent to KOMBU processing your photograph to generate the personalized video.
- You are responsible for the content you upload and any violation of third-party rights.

### 6. Video Generation

- KOMBU uses automated technology to generate your personalized video.
- The video is created based on your ratings, photograph, and restaurant information.
- We reserve the right to improve the video generation process at any time.

### 7. Intellectual Property

- All content and technology on KOMBU (except your content) is property of KOMBU.
- You may not reproduce, distribute, or transmit any content without authorization.
- Your personalized video is for personal use. Sale, commercialization, or public distribution is not permitted without permission.

### 8. Limitation of Liability

KOMBU is provided "as is" without warranties of any kind. We are not responsible for:
- Service interruptions or technical failures.
- Data loss or corruption.
- Indirect, incidental, or consequential damages arising from the use of our services.

### 9. Cookies and Tracking Technologies

We use cookies and similar technologies to:
- Improve your user experience.
- Remember your preferences.
- Analyze the use of our services.

You can control cookies through your browser settings.

### 10. Modification of Terms

We reserve the right to modify these terms at any time. Changes will take effect when published on our site. Your continued use of the service constitutes acceptance of the modified terms.

### 11. Termination

We may suspend or terminate your access to KOMBU if you violate these terms or for other reasons.

### 12. Applicable Law

These terms are governed by applicable laws, and any dispute will be resolved in the corresponding courts.

### 13. Contact

If you have questions about these terms, contact us at support@kombu.com`,
  },
};
